import * as React from 'react'
import {Icon} from '/react4xp/components/primitives/Icon'

export interface ButtonLinkProps {
  href: string
  label: string
  newTab?: boolean
  variant: 'button' | 'button-white' | 'text-link' | 'text-link-white'
}

export const ButtonLink = ({ href, label, newTab, variant }: ButtonLinkProps) => {
  const linkProps = newTab
    ? { target: '_blank' as const, rel: 'noopener noreferrer' }
    : {}

  if (variant === 'button') {
    return (
      <a
        href={href}
        className="inline-block w-fit rounded-full bg-peach-500 px-8 py-4 uppercase text-sm font-medium text-black no-underline transition-colors hover:bg-blue-500 focus-visible:outline-1 focus-visible:outline-slate-300"
        {...linkProps}
      >
        {label}
      </a>
    )
  }

  if (variant === 'button-white') {
    return (
      <a
        href={href}
        className="inline-block w-fit rounded-full bg-white px-8 py-4 uppercase text-sm font-medium text-black no-underline transition-colors hover:bg-black hover:text-white focus-visible:outline-1 focus-visible:outline-slate-300"
        {...linkProps}
      >
        {label}
      </a>
    )
  }

  if (variant === 'text-link-white') {
    return (
      <a
        href={href}
        className="text-base leading-normal text-white underline decoration-white focus-visible:outline-1 focus-visible:outline-slate-300 md:text-2xl md:leading-relaxed"
        {...linkProps}
      >
        {label} <Icon name="arrow_forward" size={20} className="align-middle" />
      </a>
    )
  }

  return (
    <a
      href={href}
      className="text-base leading-normal text-black underline decoration-slate-900 focus-visible:outline-1 focus-visible:outline-slate-300 md:text-2xl md:leading-relaxed"
      {...linkProps}
    >
      {label} <Icon name="arrow_forward" size={20} className="align-middle" />
    </a>
  )
}
